import type { InternalAxiosRequestConfig } from "axios";

// Query parameter asset-metadata-service reads to bypass its Redis
// request/response cache (see the service's request_response_cache_service.py:
// SKIP_CACHE_QUERY_PARAM / is_skip_cache_requested). Underscore-prefixed
// because the service keeps it off its documented API surface.
export const SKIP_CACHE_PARAM = "_skip_cache";

/**
 * axios request interceptor: tag asset-metadata GETs so they read the database
 * instead of Redis. Lives apart from `apiClientAdmin` so it can be tested
 * without importing axios at runtime -- CRA's jest does not transform axios v1's
 * ESM build, and the import above is types only, so it is erased.
 */
export const applySkipCache = (
  config: InternalAxiosRequestConfig,
): InternalAxiosRequestConfig => {
  const method = (config.method ?? "get").toLowerCase();

  // Writes are never served from the cache, so tagging them would only add
  // noise to the request log.
  if (method !== "get") return config;

  // Several admin screens route absolute REACT_APP_ENTITLEMENTS_API URLs
  // through this instance. axios ignores baseURL for those, and
  // betm-entitlements-service knows nothing about the parameter, so leave them
  // alone: only calls that resolve against the asset-metadata baseURL are ours.
  if (/^https?:\/\//i.test(config.url ?? "")) return config;

  config.params = { ...(config.params ?? {}), [SKIP_CACHE_PARAM]: true };
  return config;
};
